import { setSession } from "frontend/utils/authenticateHelper.js";
import { CLIENT_ID } from "frontend/utils/constants.js";

// Creates a guest account and stores its token, so every existing API hook
// (useFetch, usePost, ActionCable) works with no further changes.
export const startGuestSession = async () => {
  const response = await fetch("/api/v1/guest", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ client_id: CLIENT_ID })
  });

  const json = await response.json();

  if (!response.ok) {
    throw new Error(json.message || "Could not start a guest game.");
  }

  setSession(json.access_token, json.username, { guest: true });

  return { username: json.username };
};
